// extracted by mini-css-extract-plugin
export default {"wrap":"PasswordResetForm_wrap__1Y9Os","note":"PasswordResetForm_note__pfg07","buttons":"PasswordResetForm_buttons__MNEiN","button":"PasswordResetForm_button__Ch+Df"};